(() => {
  const form = document.getElementById('CoffeaLocalization');
  if (!form) return;
  const country = form.elements.country_code;
  const language = form.elements.language_code;
  const preferenceKey = 'coffea-localization-choice';
  const menu = form.closest('[data-localization-menu]');
  const selectedFlag = form.querySelector('[data-selected-country-flag]');
  const syncSelectedFlag = () => {
    const flagUrl = country.selectedOptions[0]?.dataset.flagUrl;
    if (!selectedFlag || !flagUrl) return;
    selectedFlag.src = flagUrl;
    selectedFlag.removeAttribute('srcset');
  };
  syncSelectedFlag();
  if (menu) {
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !menu.open) return;
      menu.open = false;
      menu.querySelector('summary').focus();
      event.stopPropagation();
    });
    document.querySelector('.menu-toggle')?.addEventListener('click', () => { menu.open = false; });
  }
  let languageChanged = false;
  language.addEventListener('change', () => { languageChanged = true; });
  country.addEventListener('change', () => {
    syncSelectedFlag();
    if (languageChanged) return;
    const preferred = country.value === 'CO' ? 'es' : 'en';
    if ([...language.options].some(option => option.value === preferred)) language.value = preferred;
  });
  form.addEventListener('submit', () => {
    try { localStorage.setItem(preferenceKey, JSON.stringify({ country: country.value, language: language.value })); } catch {}
  });
  async function localizeFirstVisit() {
    if (country.options.length < 2 || window.Shopify?.designMode) return;
    try {
      if (localStorage.getItem(preferenceKey) || sessionStorage.getItem('coffea-localization-attempt')) return;
      sessionStorage.setItem('coffea-localization-attempt', '1');
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      const detected = data.detected_values?.country?.handle || data.suggestions?.[0]?.parts?.country?.handle;
      if (!detected || detected === country.value || ![...country.options].some(option => option.value === detected)) return;
      country.value = detected;
      syncSelectedFlag();
      const preferred = detected === 'CO' ? 'es' : 'en';
      if ([...language.options].some(option => option.value === preferred)) language.value = preferred;
      form.requestSubmit();
    } catch {}
  }
  localizeFirstVisit();
})();

